import { withStyles } from 'tss-react/mui';
import { Theme247 } from "./Theme247";
// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
export const GlobalCss = withStyles(() => null, {
  '@global': {
    'p a[href]': {
      color: Theme247.palette.secondary.main,
    },
  },
});
